/* Formule unique de projection fin de période CA Jour (référence = Vue synthétique).
   Miroir backend : backend/routes/ca_projection.py — toute modification doit être faite des deux côtés. */
export const WEIGHT_STRONG = 1.15, WEIGHT_NORMAL = 0.95, TREND_DAYS = 7;

export const weekWeight = d => { const wk = Math.ceil(d.getDate() / 7); return (wk === 1 || wk >= 5) ? WEIGHT_STRONG : WEIGHT_NORMAL; };

export function periodEnd(last, scope = "month") {
  if (scope === "week") { const dow = (last.getDay() + 6) % 7; const e = new Date(last); e.setDate(last.getDate() + (6 - dow)); return e; }
  if (scope === "year") return new Date(last.getFullYear(), 11, 31);
  return new Date(last.getFullYear(), last.getMonth() + 1, 0);
}

/* byDay = [{date, realise}] ; scope = "week" | "month" | "year" */
export function projectPeriod(realise, byDay, scope = "month") {
  const done = (byDay || []).filter(d => d.date && (d.realise || 0) > 0).sort((a, b) => a.date.localeCompare(b.date));
  if (!done.length) return { projection: realise || 0, trend: 0, daysLeft: 0 };
  const last7 = done.slice(-TREND_DAYS);
  const trend = last7.reduce((a, b) => a + (b.realise || 0), 0) / last7.length;
  const last = new Date(done[done.length - 1].date.slice(0, 10) + "T00:00:00");
  const end = periodEnd(last, scope);
  let addition = 0, daysLeft = 0;
  for (const d = new Date(last); d < end;) { d.setDate(d.getDate() + 1); addition += trend * weekWeight(d); daysLeft++; }
  return { projection: (realise || 0) + addition, trend, daysLeft };
}

export const scopeFromFilters = f => f?.semaines?.length === 1 ? "week" : f?.mois?.length === 1 ? "month" : "year";
